<h3>{{title}}</h3>
<i (click)="demoSwitch()" class="fas fa-exchange-alt h3 p-3 redirect"></i>

<router-outlet></router-outlet>